<template>
  <!-- 法人申请入驻的表单-->
  <el-form :model="preexchangeForm" :rules="ruleExchangeForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
    <div>
      <!-- 基本信息 -->
      <el-card class="box-cards system-logo">
        <div slot="header" class="card-title">
          <div></div>
          <span>基本信息</span>
        </div>
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="服务机构名称：" prop="jgmc" label-width="225px">
              <el-input v-model.trim="preexchangeForm.jgmc" style="width: 600px" clearable></el-input>
            </el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="统一社会信用代码：" prop="tyshxydm" label-width="225px">
              <el-input v-model.trim="preexchangeForm.tyshxydm" style="width: 250px" clearable
                :readonly="operation"></el-input> </el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="单位法人代表身份证号：" prop="qyfrsfzh" label-width="225px">
              <el-input v-model.trim="preexchangeForm.qyfrsfzh" style="width: 250px" clearable
                :readonly="operation"></el-input> </el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="单位法人：" prop="qyfr" label-width="225px">
              <el-input v-model.trim="preexchangeForm.qyfr" style="width: 250px" clearable
                :readonly="operation"></el-input> </el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="单位法人代表联系方式：" prop="qyfrlxfs" label-width="225px">
              <el-input v-model.trim="preexchangeForm.qyfrlxfs" style="width: 250px" clearable
                :readonly="operation"></el-input> </el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="法人单位名称：" prop="frdw" label-width="225px">
              <el-input v-model.trim="preexchangeForm.frdw" style="width: 250px" clearable readonly></el-input>
            </el-form-item></el-col>
        </el-row>
        <el-row class="logo-img">
          <el-col :span="10">
            <el-form-item label="机构图片" prop="jgtpPath" label-width="550px">
              <el-upload class="avatar-uploader" :action="upload_Jgtp.action" :data="{ jgid: uuid }" :headers="upload_Jgtp.token"  :show-file-list="false"
                :before-upload="beforeAvatarUpload" :disabled="operation" :on-success="handleAvatarSuccess">
                <img v-if="preexchangeForm.jgtpPath" :src="preexchangeForm.jgtpPath" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload> </el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="注册资本（万元）：" prop="zczbwy" label-width="225px">
              <el-input v-model.trim="preexchangeForm.zczbwy" style="width: 250px" clearable
                :readonly="operation"></el-input> </el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="成立日期：" prop="zcsj" label-width="225px">
              <el-date-picker v-model="preexchangeForm.zcsj" type="date" placeholder="选择日期" format="yyyy-MM-dd"
                style="width: 250px" value-format="yyyy-MM-dd" :disabled="operation">
              </el-date-picker> </el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人：" prop="jglxr" label-width="225px">
              <el-input v-model.trim="preexchangeForm.jglxr" style="width: 250px" clearable
                :readonly="operation"></el-input> </el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="jglxrdh" label-width="225px">
              <el-input v-model.trim="preexchangeForm.jglxrdh" style="width: 250px" clearable
                :readonly="operation"></el-input> </el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="办公电话：" prop="bgdh" label-width="225px">
              <el-input v-model.trim="preexchangeForm.bgdh" style="width: 250px" clearable
                :readonly="operation"></el-input>
              <span style="color: red;margin-left: 5px;">例如：027-88888888</span>
            </el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="邮箱：" prop="yx" label-width="225px"> <el-input v-model.trim="preexchangeForm.yx"
                style="width: 250px" clearable :readonly="operation"></el-input> </el-form-item></el-col>
          <el-col :span="14">
            <el-form-item label="机构地址：" prop="jgdz" label-width="150px">
              <el-cascader ref="fAddress" v-model="preexchangeForm.jgdz" :options="divisionHbDictList"
                :props="cityDictProps" style="width: 250px" @change="handleChange" :disabled="operation">
              </el-cascader>
              <el-input v-model.trim="preexchangeForm.txdz" style="width: 380px; margin-left: 10px"
                :disabled="operation"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="专职人员数量：" prop="zzrysl" label-width="225px">
              <el-input v-model.trim="preexchangeForm.zzrysl" style="width: 250px" clearable
                :readonly="operation"></el-input> </el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="机构分类：" prop="jgfl" label-width="225px">
              <el-select v-model="preexchangeForm.jgfl" placeholder="请选择" style="width: 250px" :disabled="operation">
                <el-option v-for="item in jgflList" :key="item.dictCode" :label="item.dictValue" :value="item.dictCode">
                </el-option>
              </el-select> </el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <!-- <el-form-item label="服务领域（多选）：" prop="sscyly" label-width="570px">
              <el-checkbox-group v-model="preexchangeForm.sscyly" class="columngroup2" :disabled="operation">
                <el-checkbox v-for="(option, index) in sscylyList" :key="index" :label="option.dictCode">{{
                  option.dictValue }}</el-checkbox>
                <template v-if="preexchangeForm.sscyly.includes('99')">
                  <el-input v-model.trim="preexchangeForm.sscylyDetail" style="width: 100px;margin-left: 10px;"
                    size="mini" :disabled="operation"></el-input>
                </template>
</el-checkbox-group>
</el-form-item> -->
            <el-form-item label="服务领域（多选）：" prop="sscyly" label-width="225px" class="fwlyStyle">
              <el-checkbox-group v-model="preexchangeForm.sscyly" class="columngroup2">
                <!-- 每行最多显示5个 -->
                <el-checkbox v-for="(option, index) in sscylyList.slice(0, 5)" :key="index" :label="option.dictCode"
                  :disabled="operation">{{ option.dictValue }}</el-checkbox>
                <!-- 处理后6个单独一行的情况 -->
                <el-row :gutter="20">
                  <el-col v-for="(option, index) in sscylyList.slice(5)" :key="index" :span="24">
                    <el-checkbox :label="option.dictCode" :disabled="operation">{{ option.dictValue }}</el-checkbox>
                  </el-col>
                </el-row>
                <!-- 点击其他按钮才会展示输入框信息 -->
                <template v-if="preexchangeForm.sscyly.includes('99')">
                  <el-input v-model.trim="preexchangeForm.sscylyDetail" style="width: 200px;"
                    size="mini" :disabled="operation"></el-input>
                </template>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="经营范围：" prop="jyfw" label-width="225px">
              <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="preexchangeForm.jyfw"
                style="width: 1000px" :readonly="operation" maxlength="300" show-word-limit> </el-input>
            </el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="服务机构类型（可多选）：" prop="fwjglx" label-width="225px" class="fwlyStyle">
              <el-checkbox-group v-model="preexchangeForm.fwjglx" :disabled="operation" @change="changeCheckBox">
                <el-checkbox v-for="(option, index) in fwjglxList" :key="index" :label="option.dictCode">{{
                  option.dictValue }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item></el-col>
        </el-row>
        <el-row :gutter="20" v-if="preexchangeForm.fwjglx.includes('04')">
          <el-col>
            <el-form-item label="是否为ICP和ISP：" prop="isIcpisp" label-width="225px">
              <el-radio v-model="preexchangeForm.isIcpisp" label="0">否</el-radio>
              <el-radio v-model="preexchangeForm.isIcpisp" label="1">是</el-radio>
            </el-form-item>
          </el-col>
          <el-col v-if="preexchangeForm.isIcpisp == 1">
            <el-form-item label="资质证书有效期（研发服务）:" prop="yfEZsyxrq" label-width="225px">
              <el-date-picker v-model="preexchangeForm.yfEZsyxrq" type="date" placeholder="选择日期"
                format="yyyy-MM-dd HH:mm:ss" style="width: 250px" value-format="yyyy-MM-dd HH:mm:ss"
                :disabled="operation">
              </el-date-picker>
            </el-form-item></el-col>
        </el-row>
        <el-row :gutter="20" v-if="preexchangeForm.fwjglx.includes('02')">
          <el-col :span="12">
            <el-form-item label="资质证书有效期（检验检测）:" prop="jyjcZsyxrq" label-width="225px">
              <el-date-picker v-model="preexchangeForm.jyjcZsyxrq" type="date" placeholder="选择日期"
                format="yyyy-MM-dd HH:mm:ss" style="width: 250px" value-format="yyyy-MM-dd HH:mm:ss"
                :disabled="operation">
              </el-date-picker>
            </el-form-item></el-col>
        </el-row>
        <el-row v-if="preexchangeForm.fwjglx.includes('02')">
          <el-col :span="24">
            <el-form-item label="检验类别:" label-width="225px" class="jylb">
              <el-input v-model.trim="input.value" v-for="(input, index) in jylbInputs" :key="index"
                style="width: 250px;margin-left: 5px;" :disabled="operation"></el-input>
              <span style="margin-left: 10px;color: rgb(92, 182, 255);font-size: 18px;cursor: pointer;"
                @click="addInput" v-if="!operation">
                <i class="el-icon-circle-plus"></i>
              </span>
              <span style="margin-left: 10px;color: rgb(245, 108, 108);font-size: 18px;cursor: pointer;"
                @click="removeInput" v-if="!operation">
                <i class="el-icon-remove" style="margin-left: 5px;"></i>
              </span>
            </el-form-item></el-col>
        </el-row>
      </el-card>
      <!-- 附件上传 -->
      <el-card class="box-cards upload-attachments">
        <div slot="header" class="card-title">
          <div></div>
          <span>附件上传</span>
          <span
            style="color: red; font-weight: 800; margin-left: 10px;font-size: 15px">注：以下材料均需要清晰，并按以下各项附件栏目提示要求加盖公章。（上传附件请提供pdf格式文件,可上传多个文件）</span>
        </div>
        <template v-for="(item, index) in wjlxList">
          <el-row :gutter="50" :key="item.dictCode"
            v-if="fwTypeList.indexOf(item.dictCode) == -1 || reflectionArr.indexOf(item.dictCode) != -1">
            <el-col :span="6"><span class="upload-title">{{ index + 1 + '、' + item.dictValue }}</span></el-col>
            <el-col :span="10" style="display: flex; flex-direction: column">
              <el-upload ref="uploadFile" class="upload-demo" :action="upload.action" :headers="upload.token"
                :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" :limit="1"
                :show-file-list="false" :before-upload="beforeAvatarUpload2" :on-success="(response, file, fileList) => {
                  return handUploadFileSuccess(response, file, fileList, item.dictCode)
                }
                  " :on-error="handUploadFileError" :data="{ jgid: uuid, wjlx: item.dictCode }" accept=".pdf"
                :disabled="operation">
                <span style="color: red; margin-right: 5px; font-size: 16px; font-weight: bold"
                  v-if="item.routeUrl === '1'">*</span>
                <span class="upload-icon"><i class="el-icon-upload2"></i>上传</span>
              </el-upload>
              <div class="up-list_item">
                <div class="up-list_item_row" v-for="(item2, index2) in item.fileList" :key="index2">
                  <div class="fileName">
                    <el-link type="success" icon="el-icon-document" :underline="false" :title="item2.wjm">{{ item2.wjm }} （{{ item2.wbdx |
                      bytesToKB }}）</el-link>
                  </div>
                  <div class="fileTools">
                    <el-button size="small" type="text" class="text-danger" @click="removeFile(item2.fjid)"
                      :disabled="operation">删除 </el-button>
                    <el-button size="small" type="text" @click="previewFile(item2.fjid)">预览 </el-button>
                    <el-button size="small" type="text" @click="downloadFile(item2.fjid)">下载</el-button>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div>
                <template v-if="item.dictCode === '026' || item.dictCode === '027'">
                  <span class="upload-waring" v-html="item.remark"></span>
                  <!-- 请查看 -->
                  <span
                    style="color: rgb(86, 165, 253); text-decoration: underline; cursor: pointer; font-size: 16px;margin-left: 5px;"
                    @click="previewFileTemplateManage(item)" v-if="item.auxiliaryValue">请查看</span>
                </template>
                <template v-else-if="item.dictCode === '025'">
                  <div v-for="(item2, index) in item.auxiliaryValue.split(';')" :key="index">
                    <span class="upload-waring">{{ item.remark.split(';')[index] }}</span>
                    <!-- 请查看 -->
                    <!-- <span
                      style="color: rgb(86, 165, 253); text-decoration: underline; cursor: pointer; font-size: 16px;margin-left: 5px;"
                      @click="previewFileTemplateManage(item2, '检验检测')" v-if="item.auxiliaryValue">请查看2</span> -->
                    <br />
                  </div>
                  <span class="upload-waring">CMA样例: <span
                      style="color: rgb(86, 165, 253); text-decoration: underline; cursor: pointer; font-size: 16px;margin-left: 5px;"
                      @click="previewFileTemplateManage(item.auxiliaryValue.split(';')[0], '检验检测')">请查看</span></span>
                  <span class="upload-waring" style="margin-left:15px">CNAS样例:<span
                      style="color: rgb(86, 165, 253); text-decoration: underline; cursor: pointer; font-size: 16px;margin-left: 5px;"
                      @click="previewFileTemplateManage(item.auxiliaryValue.split(';')[1], '检验检测')">请查看</span></span>
                </template>
                <template v-else-if="item.dictCode === '006'">
                  <div v-for="(item2, index) in item.auxiliaryValue.split(';')" :key="index">
                    <span class="upload-waring">{{ item.remark.split(';')[index] }}</span>
                    <!-- <br /> -->
                  </div>
                  <span class="upload-waring">样例1: <span
                      style="color: rgb(86, 165, 253); text-decoration: underline; cursor: pointer; font-size: 16px;margin-left: 5px;"
                      @click="previewFileTemplateManage(item.auxiliaryValue.split(';')[0], '检验检测')">请查看</span></span>
                  <span class="upload-waring" style="margin-left:15px">样例2:<span
                      style="color: rgb(86, 165, 253); text-decoration: underline; cursor: pointer; font-size: 16px;margin-left: 5px;"
                      @click="previewFileTemplateManage(item.auxiliaryValue.split(';')[1], '检验检测')">请查看</span></span>
                </template>
                <template v-else>
                  <span class="upload-waring" v-html="item.remark"></span>
                  <!-- 下载模板 -->
                  <span style="color: rgb(86, 165, 253); text-decoration: underline; cursor: pointer; font-size: 16px"
                    @click="handleDownTemplate(item)" v-if="item.auxiliaryValue">下载模板</span>
                </template>
              </div>
            </el-col>
          </el-row>
        </template>
      </el-card>
      <!-- 审核流程信息 -->
      <el-card class="box-cards shlc" v-if="shlcStatus">
        <div slot="header" class="card-title">
          <div></div>
          <span>审核流程信息</span>
        </div>
        <el-steps :active="currentActive" finish-status="success" align-center>
          <el-step title="机构提交"></el-step>
          <el-step title="审核"></el-step>
          <el-step title="机构公示"></el-step>
          <el-step title="入驻成功"></el-step>
        </el-steps>
        <JRtable :table-data="currentUsersData2" :selection="false" :column="currentUsersColumns2" size="mini"
          :border="true" :pageOptions="pageOptions2" @page-change="handlePageChange2" :index="true">
        </JRtable>
      </el-card>
      <!-- 提交操作栏 -->
      <el-row style="display: flex; flex-direction: column; justify-content: space-around">
        <el-col :span="24" style="display: flex; justify-content: center" v-if="!operation">
          <el-checkbox v-model="checked" class="submit_checkbox"></el-checkbox>
          <span style="color: red; margin-left: 10px; font-weight: bold; font-size: 16px">*</span>
          <span style="font-weight: bold; font-size: 16px"
            @click="checked = !checked">我单位声明：此次提交的申报材料均真实、合法；如有不实之处，愿负相应的法律责任，并承担由此产生的一切后果。特此声明！</span>
        </el-col>
        <br />
        <el-col :span="24" style="display: flex; justify-content: center" v-if="!operation">
          <el-button size="small" type="success" @click="submitExchangeForm('保存', { linkCode: '001', status: '003' })"
            style="width: 100px">保存</el-button>
          <el-button size="small" type="primary" @click="submitExchangeForm('新增', { linkCode: '005', status: '004' })"
            style="width: 100px" :disabled="!checked">提交</el-button>
          <el-button size="small" @click="$emit('closeDialog')" style="width: 100px">取消</el-button>
        </el-col>
        <el-col :span="24" style="display: flex; justify-content: center" v-if="see && operation">
          <el-button size="small" @click="$emit('closeDialog')" style="width: 100px">关闭</el-button>
        </el-col>
      </el-row>
    </div>
  </el-form>
</template>
<script>
import { printPdfView, downloadFileRecord, removeFileRecord, getJgDetail } from '@/api/mechanism/enterApply'
import { getDictionaryList, recursionDictData } from '@/api/enterprise/exchangelist'
import { enterApply, downloadFileTemplateManage, getJgFileList, getJgrzGcList, getfwJgLxType } from '@/api/mechanism/enterApply'
import { getToken } from '@/utils/cache'
import { validateUniscid, validateEmail, validateMobile, validateOfficTelephone, validateIdCard } from '@/utils/jr-validate.js'
import { previewFileTemplateManage } from '@/api/index.js'
import JRtable from '@/components/Table'

export default {
  props: {
    // 当前的唯一标识
    uuid: {
      type: String,
      default: ''
    },
    // 是否禁用
    operation: {
      type: Boolean,
      default: false
    },
    // 是否显示退回消息
    sendBack: {
      type: Boolean,
      default: false
    },
    // 是否显示流程图
    shlcStatus: {
      type: Boolean,
      default: false
    },
    // 是否有关闭按钮
    see: {
      type: Boolean,
      default: true
    },
    // 是否展示三级机构审核
    sanji: {
      type: Boolean,
      default: false
    }
  },
  components: {
    JRtable
  },
  filters: {
    bytesToKB: function (bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      let size = bytes / k
      let unit = 'KB'
      if (size > k) {
        size /= k
        unit = 'MB'
      }
      return size.toFixed(2) + ' ' + unit
    }
  },
  data() {
    return {
      upload_Jgtp: {
        action: process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factJgjbxxb/uploadJgtp',
        token: {
          Internettoken: getToken()
        }
      },
      // 入驻申请表单对应的form信息
      preexchangeForm: {
        jgmc: this.$store.state.user.enterName,
        tyshxydm: this.$store.state.user.tyshxydm,
        parentJglxr: '',
        parentJglxrdh: '',
        bgdh: '',
        qyfr: this.$store.state.user.legalName,
        qyfrlxfs: this.$store.state.user.phone,
        jgtpPath: '',
        txdz: '',
        mhwz: '',
        lxdh: '',
        zcsj: '',
        jyjcZsyxrq: '',
        yfEZsyxrq: '',
        isIcpisp: '0',
        jgjj: '',
        jgszqy: '',
        qyfrsfzh: this.$store.state.user.legalCard,
        jglxr: '',
        jglxrdh: '',
        gskhh: '',
        gszhmc: '',
        gszhzh: '',
        khhhh: '',
        khzhlxdh: '',
        khzhdz: '',
        zhmc: '',
        jgshzt: '',
        // shsm: '',
        sjly: '',
        sqrzrq: '',
        zczbwy: '',
        yx: '',
        zzrysl: '',
        jyfw: '',
        fwjglx: [],
        cjr: '',
        frdw: this.$store.state.user.enterName,
        gdbs: '',
        jgfl: '',
        rzpc: '',
        jgszs: '',
        jgdz: [],
        shsm: '',
        jgytdw: '',
        jgzl: '',
        ejdwInfo: null,
        parentJgid: '',
        // 企业所属领域
        sscyly: [],
        // 企业所属领域详情
        sscylyDetail: ''
      },
      // 企业所属领域（单选）
      sscylyList: [],
      // 入驻申请表单所需的 form 验证规则
      ruleExchangeForm: {
        // 机构名称：
        jgmc: [{ required: true, message: '请选择机构名称', trigger: 'blur' }],
        ejdwInfo: [{ required: true, message: '请选择机构单位信息', trigger: 'blur' }],
        parentJglxr: [{ required: true, message: '该所属机构联系人暂无数据', trigger: 'blur' }],
        parentJglxrdh: [{ required: true, message: '请输入机构联系方式', trigger: 'blur' }],
        bgdh: [
          { required: true, message: '请输入办公电话', trigger: 'change' },
          { validator: validateOfficTelephone, trigger: 'change' }
        ],
        jglxr: [{ required: true, message: '请输入机构联系人', trigger: 'blur' }],
        jglxrdh: [
          { required: true, message: '请输入机构联系人电话', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' }
        ],
        yx: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' }
        ],
        jgdz: [{ required: true, message: '请选择机构所在地址', trigger: 'change' }],
        tyshxydm: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
          { validator: validateUniscid, trigger: 'blur' }
        ],
        qyfrlxfs: [
          { required: true, message: '请输入单位法人代表联系方式', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' }
        ],
        qyfr: [{ required: true, message: '请输入单位法人', trigger: 'blur' }],
        frdw: [{ required: true, message: '请输入法人单位名称', trigger: 'blur' }],
        jgtpPath: [{ required: true, message: '请上传机构图片', trigger: 'change' }],
        zczbwy: [{ required: true, message: '请输入注册资本（万元）', trigger: 'blur' },
        { pattern: /^\d+(\.\d+)?$/, message: '只能输入数字类型的值', trigger: 'blur' }
        ],
        zcsj: [{ required: true, message: '请选择成立日期', trigger: 'blur' }],
        jyjcZsyxrq: [{ required: true, message: '请选择资质证书有效期', trigger: 'change' }],
        yfEZsyxrq: [{ required: true, message: '请选择资质证书有效期', trigger: 'change' }],
        isIcpisp: [{ required: true, message: '请选择是否为ICP和ISP', trigger: 'change' }],
        qyfrsfzh: [{ required: true, message: '请输入正确的身份证号', trigger: 'blur' },
        // { validator: validateIdCard, trigger: 'blur' }
        ],
        zzrysl: [{ required: true, message: '请输入专职人员数量', trigger: 'blur' },
        { pattern:  /^(0|[1-9]\d*)$/, message: '只能输入0或者大于0的整数', trigger: 'blur' }
        ],
        jgfl: [{ required: true, message: '请选择机构分类', trigger: 'change' }],
        fwjglx: [{ required: true, message: '请选择服务机构类型', trigger: 'change' }],
        jyfw: [{ required: true, message: '请输入经营范围', trigger: 'change' }],
        // 企业所属领域
        sscyly: [{ required: true, message: '请选择服务领域', trigger: 'change' }],
        // 企业所属领域详情
        sscylyDetail: [{ required: true, message: '请输入服务领域详情', trigger: 'blur' }]
      },
      // 下拉框选择的数据
      selecteValue: '',
      // 下拉框的数据
      options: [],
      // 机构LOGO图片信息
      imageUrl: '',
      isDisabled: false, //查看禁止填写
      fwjglxList: [], //服务机构类型数组
      jgflList: [], //机构分类数组
      wjlxList: [], //文件类型数组
      fwTypeList: ['006', '025', '026', '027'],//服务分类文件编码
      reflectionArr: [],//服务分类文件编码
      // 湖北省行政区划字典
      divisionHbDictList: [],
      divisionHbDictList2: [],
      cityDictProps: {
        label: 'dictValue',
        value: 'dictCode',
        children: 'childSysDictionaryList'
      },
      cityDictProps2: {
        label: 'jgmc',
        value: 'jgid',
        children: 'childList'
      },
      upload: {
        action: process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factJgjbxxb/uploadJgrzsqFile',
        token: {
          Internettoken: getToken()
        }
      },
      // 是否勾选了同意协议
      checked: false,
      currentUsersColumns2: [
        // {
        //   label: '操作环节',
        //   prop: 'czhjName',
        //   align: 'center'
        // },
        {
          label: '状态',
          prop: 'spztName',
          align: 'center'
        },
        {
          label: '操作人',
          prop: 'spr',
          align: 'center'
        },
        {
          label: '操作时间',
          prop: 'spsj',
          align: 'center'
        },
        {
          label: '说明',
          prop: 'spsm',
          align: 'center'
        }
      ],
      // 审核流程信息表格数据
      currentUsersData2: [],
      // 分页数据2
      pageOptions2: {
        page: 1,
        limit: 10,
        total: 0
      },
      // 当前步骤条的索引
      currentActive: 0,
      // 当前条的信息
      itemInfo: null,
      // 检验类别的输入框数据列表
      jylbInputs: [{ value: '' }]
    }
  },
  async created() {
    // 获取字典类型
    this.getDictionaryList()
    // 查询企业地址信息
    this.handleGetHbDivision()
  },
  mounted() { },
  methods: {
    // 检验类别输入框的添加按钮
    addInput() {
      this.jylbInputs.push({ value: '' }); // 点击按钮添加一个输入框
    },
    // 检验类别输入框的删除按钮
    removeInput() {
      if (this.jylbInputs.length > 1) {
        this.jylbInputs.pop(); // 点击按钮删除最后一个输入框
      }
    },
    // 兑付流程分页控制
    handlePageChange2(val) {
      this.pageOptions2.page = val.page
      this.pageOptions2.limit = val.limit
      this.getPageExchangeProcessList()
    },
    // 分页查询兑付过程信息
    getPageExchangeProcessList() {
      let params = {
        jgid: this.uuid,
        page: this.pageOptions2.page,
        size: this.pageOptions2.limit
      }
      getJgrzGcList(params)
        .then((res) => {
          if (res.code === 200) {
            this.currentUsersData2 = res.data.records
            this.pageOptions2.total = res.data.total
          } else {
            this.$message.error('获取兑付过程信息失败')
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    async getDictionaryList() {
      // 服务机构类型
      let a = await getfwJgLxType()
      // 机构分类
      let b = await getDictionaryList({
        parentCode: 'DIM_JGFL'
      })
      // 附件上传文件类型
      let c = await getDictionaryList({
        parentCode: 'DIM_WJLX'
      })
      // 企业所属领域（单选）
      let d = await getDictionaryList({
        parentCode: 'DIM_SSZYLY'
      })
      // 处理请求结果
      if (a.code === 200) {
        this.fwjglxList = a.data
      }
      if (b.code === 200) {
        this.jgflList = b.data
      }
      if (c.code === 200) {
          this.wjlxList = c.data.filter((item) => {
            this.$set(item, 'fileList', [])
            return item.tags === '申请机构入驻'
          })
      }
      if (d.code === 200) {
        this.sscylyList = d.data
      }
    },
    // 查询湖北省行政区划
    handleGetHbDivision() {
      let params = {
        parentId: '420000',
        level: '3'
      }
      recursionDictData(params).then((response) => {
        const { data } = response

        this.divisionHbDictList.push(data)
      })
    },
    // 选择级联地址
    handleChange() {
      const pathLabels = this.$refs.fAddress.getCheckedNodes()[0].pathLabels
      this.preexchangeForm.txdz = pathLabels.join('').replaceAll('省直辖县级行政区划', '')
    },
    // 提交表单信息,接受三个参数，当前提交状态，当前的操作环节码
    submitExchangeForm(status, codeMsg, type) {
      if (status === '新增') {
        // 需要做表单校验
        this.$refs.ruleForm.validate((valid) => {
          if (!valid) {
            this.moveToErr()
          } else {
            // 判断附件文件上传的完整性，通过字典中的路由地址来判断，如果需要更改则在后台管理中进行配置
            const result = this.wjlxList.some((e) => {
              return e.routeUrl === '1' && e.fileList.length == 0
            })
            // 说明存在有必填标识，但是文件数据为空
            if (result) {
              this.$message.warning('请先上传所需的附件，再进行提交表单')
              this.moveToErrFile('upload-attachments')
              return
            }
            this.submitApplyPost(status, codeMsg, '申请入驻', type)
          }
        })
      } else {
        this.submitApplyPost(status, codeMsg, '', type)
      }
    },
    moveToErr() {
      this.$nextTick(() => {
        let isError = document.getElementsByClassName('is-error')
        if (isError.length) {
          isError[0].scrollIntoView({
            block: 'center',
            behavior: 'smooth'
          })
        }
      })
    },
    moveToErrFile(className) {
      this.$nextTick(() => {
        let isError = document.getElementsByClassName(className)
        isError[0].scrollIntoView({
          block: 'center',
          behavior: 'smooth'
        })
      })
    },
    async submitApplyPost(status, codeMsg, spyj, type) {
      const list = { ...this.preexchangeForm }
      list.jgid = this.uuid
      // 需要处理机构分类、机构地址、企业支持类型
      // 机构分类
      if (list.fwjglx.length) {
        list.fwjglx = list.fwjglx.join(';')
      } else {
        list.fwjglx = ''
      }
      // 服务领域多选
      if (list.sscyly.length) {
        list.sscyly = list.sscyly.join(';')
      } else {
        list.sscyly = ''
      }
      if (list.jgdz.length > 0) {
        list.jgszs = list.jgdz[1]
        list.jgszqy = list.jgdz[2]
      } else {
        list.jgszs = ''
        list.jgszqy = ''
      }
      // 处理图片数据
      // if (list.jgtpPath) {
      //   list.jgtpPath = list.jgtpPath.split(',')[1]
      // } else {
      //   list.jgtpPath = ''
      // }
      // 判断三级机构是否填写信息
      if (list.ejdwInfo) {
        list.parentJgid = list.ejdwInfo[1]
      }
      if (list.fwjglx.includes('02')) {
        let result = this.jylbInputs.map(obj => obj.value).join(';');
        list.jylb = result
      }
      // 封装成一个对象newList，传递给后端
      let newList = {
        // 操作环节
        linkCode: codeMsg.linkCode,
        // 兑付状态
        status: codeMsg.status,
        formData: list,
        adviceContent: spyj
      }
      const result = await enterApply(newList)
      if (result.code == 200) {
        if (type === '三级') {
          this.$confirm('请联系审核员进行审核', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
          }).catch(() => {
          });
        } else {
          this.$message.success('操作成功')
        }
        // 再获取一遍数据
        this.$emit('getJgrzList')
        // 如果第一个保存提交是不会关闭弹窗的，第二个点击保存按钮是会关闭弹窗的
        if (status === '保存1') {
          return false
        }
        this.$emit('closeDialog')
      } else {
        this.$message.error(result.message)
      }
    },
    handleAvatarSuccess(res) {
      this.preexchangeForm.jgtpPath = res.data
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 4
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG /png格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 4MB!')
      }
      return isJPG && isLt2M
    },
    // 限制不超过4M
    beforeAvatarUpload2(file) {
      const isPDF = file.type === 'application/pdf'
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isPDF) {
        this.$message.error('上传附件只能是 PDF 格式!')
      }
      if (!isLt10M) {
        this.$message.error('上传pdf文件不能超过 10MB!')
      }
      return isPDF && isLt10M
      // return isPDF
    },
    beforeRemove(file, fileList) {
      if (file && file.status == 'success') {
        return this.$confirm(`确定移除 ${file.name}？`)
      }
    },
    handleRemove(file, fileList) {
      // 删除图片
      console.log('handleRemove', file, fileList)
    },
    // 查看文件
    handlePreview(file) {
      console.log(file)
    },
    // 上传文件成功
    handUploadFileSuccess(response, file, fileList, dictCode) {
      if (response && response.code === 200) {
        this.$message.success('上传成功')
        // 回传事件，进行附件记录的更新
        this.getExchangeListAttach(this.uuid)
        let uploadFile = this.$refs.uploadFile.filter((item) => {
          return item.data.wjlx == dictCode
        })[0]
        uploadFile.clearFiles()
      } else {
        this.$message.error('上传失败')
      }
    },
    // 上传失败
    handUploadFileError() {
      this.$message.error('上传失败')
    },
    //删除文件
    removeFile(fileId) {
      this.$modal
        .confirm('是否删除该附件')
        .then(function () {
          return removeFileRecord({ fileId: fileId })
        })
        .then((res) => {
          // 成功之后
          if (res.code === 200) {
            if (res.data == '操作成功') {
              this.$message.success('删除成功')
              this.getExchangeListAttach(this.uuid)
            } else {
              this.$message.error('删除失败')
            }
          }
        })
    },
    // 预览文件
    previewFile(fileId) {
      let params = {
        fileId,
        InternetToken: getToken()
      }
      var paramsStr = Object.keys(params)
        .map((item) => item + '=' + params[item])
        .join('&')
      //预览文件
      window.open(printPdfView(paramsStr))
    },
    // 下载文件
    downloadFile(fileId) {
      let params = {
        fileId,
        InternetToken: getToken()
      }
      var paramsStr = Object.keys(params)
        .map((item) => item + '=' + params[item])
        .join('&')
      window.open(downloadFileRecord(paramsStr), '_blank')
    },
    // 查看兑付详情所有的附件
    async getExchangeListAttach(val) {
      const result = await getJgFileList({
        jgid: val
      })
      const { data } = result
      if (data.length == 0) {
        this.wjlxList.forEach((element) => {
          this.$set(element, 'fileList', [])
        })
        return
      } else {
        this.wjlxList = this.mergeFilesByCode(this.wjlxList, data, 'dictCode', 'wjlx')
      }
    },
    // 定义一个函数来将 dataList 添加到 wjlxList 的 fileList 中
    mergeFilesByCode(wjlxList, dataList, dictCodeKey, wjlxKey) {
      // 将 dataList 按照 wjlx 分组
      const groupedData = dataList.reduce((acc, obj) => {
        const key = obj[wjlxKey]
        if (!acc[key]) {
          acc[key] = []
        }
        acc[key].push(obj)
        return acc
      }, {})

      // 遍历 wjlxList，将对应的 fileList 填充
      wjlxList.forEach((item) => {
        const wjlx = item[dictCodeKey]
        if (groupedData[wjlx]) {
          this.$set(
            item,
            'fileList',
            groupedData[wjlx].map((obj) => {
              return obj
            })
          )
        } else {
          this.$set(item, 'fileList', [])
        }
      })

      return wjlxList
    },
    // 企业承诺书模板、企业完税证明模板下载
    handleDownTemplate(item) {
      window.location.href = downloadFileTemplateManage(item.auxiliaryValue)
    },
    // 请查看
    previewFileTemplateManage(item, stringValue) {
      if (stringValue === '检验检测') {
        window.open(previewFileTemplateManage(item))
      } else {
        window.open(previewFileTemplateManage(item.auxiliaryValue))
      }
    },
    // 点击编辑按钮
    async editForm(item) {
      await this.getDictionaryList()
      // 获取当前入驻流程图
      await this.getPageExchangeProcessList()
      const result = await getJgDetail({
        jgid: item.jgid
      })
      if (result.code == 200) {
        const { data } = result
        this.itemInfo = data
        this.preexchangeForm = data
        // 回显服务机构类型
        if (data.fwjglx === null) {
          this.preexchangeForm.fwjglx = []
        } else {
          this.preexchangeForm.fwjglx = data.fwjglx.split(';')
          // 回显服务机构类型所选的文件附件
          this.changeCheckBox(this.preexchangeForm.fwjglx)
        }
        // 回显服务领域
        if (data.sscyly === null) {
          this.preexchangeForm.sscyly = []
        } else {
          this.preexchangeForm.sscyly = data.sscyly.split(';')
        }
        // 回显机构地址
        // 企业地址级联选择器
        if (data.jgszqy === null) {
          // this.preexchangeForm.jgdz = []
          this.$set(this.preexchangeForm, 'jgdz', [])
        } else {
          // this.preexchangeForm.jgdz = ['420000', data.jgszs, data.jgszqy]
          this.$set(this.preexchangeForm, 'jgdz', ['420000', data.jgszs, data.jgszqy])
        }

        // 回显上传文件的信息
        this.getExchangeListAttach(item.jgid)

        // 回显图片
        // if (data.jgtpPath) {
        //   this.$set(this.preexchangeForm, 'jgtpPath', `data:image/png;base64,${data.jgtpPath}`)
        // }
        // 回显检验类别
        if (data.jylb) {
          this.jylbInputs.length = 0
          let valuesToAdd = data.jylb.split(';');
          // 将拆分后的值逐个添加到 arr1 中
          valuesToAdd.forEach(value => {
            this.jylbInputs.push({ value });
          });
        }
        let spzt = data.jgshzt
        // if (spzt === '003' || spzt === '002' || spzt === '001') {
        //   this.currentActive = 0
        // } else if (spzt === '004' || spzt === '006' || spzt === '011' || spzt === '012') {
        //   this.currentActive = 1
        // } else if (spzt === '005' || spzt === '008' || spzt === '007') {
        //   this.currentActive = 2
        // } else if (spzt === '010' || spzt === '071') {
        //   this.currentActive = 3
        // } else if (spzt === '009') {
        //   this.currentActive = 5
        // }
        if (spzt === '003' || spzt === '002' || spzt === '001') {
          this.currentActive = 0
        } else if (spzt === '004' || spzt === '006' || spzt === '011' || spzt === '012' || spzt === '061' || spzt === '005' || spzt === '006') {
          this.currentActive = 1
        } else if (spzt === '010' || spzt === '071' || spzt === '007') {
          this.currentActive = 2
        } else if (spzt === '009') {
          this.currentActive = 4
        }
        // 回显所选的二级单位机构信息 一级chiefJgid   二级parentJgid
        if (data.parentJgid != null) {
          this.preexchangeForm.ejdwInfo = [data.chiefJgid, data.parentJgid]
        } else {
          this.preexchangeForm.ejdwInfo = []
        }
      } else {
        this.$message.error('获取详情数据失败')
      }
    },
    // 选择服务机构分类复选框
    changeCheckBox(value) {
      // value 01为大型科学006;  02检验检测025;  03研发服务一026;  04研发服务二027
      this.reflectionArr = []
      value.forEach((element) => {
        if (element === '01') {
          this.reflectionArr.push('006')
        } else if (element === '02') {
          this.reflectionArr.push('025')
        } else if (element === '03') {
          this.reflectionArr.push('026')
        } else if (element === '04') {
          this.reflectionArr.push('027')
        }
      })
      // 使用 map 方法遍历 arr1 数组，并根据匹配情况修改 routeUrl 字段
      this.wjlxList = this.wjlxList.map((item) => {
        if (item.dictCode === '006' || item.dictCode === '025' || item.dictCode === '026' || item.dictCode === '027') {
          if (this.reflectionArr.includes(item.dictCode)) {
            return { ...item, routeUrl: '1' }
          } else {
            return { ...item, routeUrl: '0' }
          }
        } else {
          return { ...item, routeUrl: '1' }
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.content {
  .grid {
    width: 1400px;
    // min-height: 942px;
    background: #ffffff;
    padding-bottom: 20px;
    margin-bottom: 40px;
  }

  .grid-box {
    width: 1200px;
    margin: 0 auto;
    padding-top: 20px;
    box-sizing: border-box;
  }

  .breadcrumb {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.4);
  }

  .active {
    color: #00000066;
  }

  .cont-box {
    margin-top: 12px;
    width: 1200px;
    min-height: 500px;
    border: 1px solid #dfdfdf;
    padding: 15px 20px;
    text-align: center;

    .cont-header {
      text-align: right;
    }

    .content-text {
      padding: 26px 50px;
      text-align: left;
    }

    .table-container {
      padding: 10px 0;
    }
  }
}

// 企业兑付申请表单样式
.applyform {
  padding: 10px;

  .box-cards {
    margin-bottom: 10px;

    .card-title {
      display: flex;
      align-items: center;

      div {
        width: 5px;
        height: 13px;
        background: rgb(88, 155, 248);
        margin-right: 10px;
      }

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }

    .el-checkbox-group {
      display: flex;
      flex-direction: column;
    }
  }
}

::v-deep .el-form {
  .el-form-item {
    display: flex;
  }

  .el-form-item__content {
    margin-left: 10px !important;
  }
}

::v-deep .columngroup {
  display: flex;
  flex-direction: column;

  .el-radio {
    margin-bottom: 10px;
  }
}

::v-deep .columngroup2 {
  display: flex;
  flex-direction: row !important;
  flex-wrap: wrap;

  .el-radio {
    margin-bottom: 10px;
  }
}

::v-deep .columngroup3 {
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  .el-radio {
    margin-bottom: 10px;
  }
}

.warnig_text {
  color: red;
  font-weight: bold;
  margin-left: 15px;
  font-size: 16px;
}

::v-deep.upload-attachments {
  .el-card__body {
    .el-row {
      min-height: 100px;
      border-bottom: 1px solid rgb(205, 211, 220);
      display: flex;
      align-items: center;

      .upload-title {
        font-weight: 800;
        font-size: 15px;
        color: #606266;
      }

      .upload-icon {
        cursor: pointer;
        font-size: 16px;
        color: rgb(86, 165, 253);

        i {
          margin-right: 5px;
        }
      }

      .upload-waring {
        color: red;
        font-size: 16px;
      }
    }
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.system-logo {
  position: relative;

  .logo-img {
    position: absolute;
    top: 10%;
    left: 58%;

    .el-form-item {
      align-items: center;
    }
  }
}

.avatar-uploader {
  line-height: 10px;
  border: 1px dashed #d9d9d9 !important;
}

.el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 200px;
  line-height: 200px;
  text-align: center;
}

.avatar {
  width: 200px;
  height: 200px;
  display: block;
}

.up-list_item {
  background: rgba(144, 161, 183, 0.06);

  .up-list_item_row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
      background: #f4f5f5;
    }

    .fileName .el-link {
      font-size: 15px;
      display: inline;
    }

    .fileName {
      width: 400px; /* 设置固定宽度 */
      white-space: nowrap; /* 防止换行 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 超出部分用省略号显示 */
    }
  }
}

::v-deep .shlc {
  .el-step__title {
    font-size: 14px !important;
  }

  .el-step__head.is-process {
    color: rgb(90, 156, 248);
    border-color: rgb(90, 156, 248);
  }

  .el-step__title.is-process {
    color: rgb(90, 156, 248);
  }
}

::v-deep .fwlyStyle {
  .el-form-item__content {
    flex: 1 !important;
  }
}
::v-deep .submit_checkbox{
  .el-checkbox__inner{
    border-color: #606266;
  }
}
::v-deep .jylb .el-form-item__content{
  flex: 1;
}
</style>
